(function() {
    'use strict';
    angular
        .module('quantixApp')
        .controller('CompanyReportAxisAmcExtController', CompanyReportAxisAmcExtController);
    CompanyReportAxisAmcExtController.$inject = ['$scope', '$rootScope', 'GenericService', 'Principal','GenericServiceNew', 'CompanyReportService', 'FinancialSensitivityService','$http','$timeout', '$state', '$uibModal', '$filter', '$window', '$sce', 'AuthKeycloak'];
    function CompanyReportAxisAmcExtController($scope, $rootScope, GenericService, Principal,GenericServiceNew, CompanyReportService,FinancialSensitivityService, $http,$timeout, $state, $uibModal, $filter, $window, $sce, AuthKeycloak) {
    	$scope.isExternal= false;
        $scope.showError = false;
        $scope.searchType = 'companyName';
		$scope.newCompanyRequest = {};
		$scope.companyObj = {};
		$scope.companyDetails = {};
		$scope.showCompanyDetails = false;
		$scope.responseMessage = '';
		$scope.selectedType = 'Select Template Type';
		$scope.companyDownloads = [];
		$scope.recentViewedCompanies = [];
		$scope.filtercompanies = []
		$scope.showManagedSubscriptionPage = false;
		var downloadReportGrid = '';
		$scope.isStandard = true;
		$scope.allTemplates = {};
		$scope.sampleReports = [];
		$scope.isPlusSubscribed = false;
		$scope.isCompInfoAdmin = false;
		$scope.samples = [{ id: 1, templateName: 'Lite' },
			{ id: 2, templateName: 'Advanced' },
			{ id: 3, templateName: 'Comprehensive' }
		]
        $scope.showNewDataFilter = false;
		$scope.toggleTemplateSelection = function() {
			$scope.selectedType = 'Select Template Type';
			if($scope.isStandard) {
				$scope.sampleReports = $scope.allTemplates.standard;
			} else {
				$scope.sampleReports = $scope.allTemplates.custom;
			}
		}
		
		Principal.identity().then(function(account){
			 if(account.isExternal =='Y'){
				 $scope.isExternal = true;
			 }else{
				 $scope.isExternal = false;
			 }
		});

        $scope.searchFilterForCompanyProfile = function (typedthings) {
            //$scope.showError = false;
            $scope.companyCode = "";
			if (typedthings == "cleanData") {
				$scope.companies = null;
			} else {
				if(typedthings.length > 1) {
					GenericServiceNew
					.getCompaniesListByNameForCompanyReport(typedthings)
					.then(function (data) {
							$scope.companies = data;
							if ($scope.companies.length == 0) {
								$scope.showError = true;
								$scope.errorMessages = "Please select a company from the suggested list.";
							} else {
								$scope.showError = false;
							}
						}, function (errordata) {
							$scope.showError = true;
							$scope.errorMessages = "Error while searching company!";
					});
				}
			}
        }
        
        $scope.selectCompany = function (companyObj) {
			$scope.companyObj = companyObj;
			var arraspersector = [];
			var i = 0;
			
				if(companyObj.companyFlag == "Manufacturing"){

					for (i = 0; i < $scope.actualcustomlist.length; i++) {
						
						if(JSON.parse($scope.actualcustomlist[i].templateJson).template.selectedSector == "G" || JSON.parse($scope.actualcustomlist[i].templateJson).template.selectedSector == "M"){
							arraspersector.push($scope.actualcustomlist[i]);
						}
					  } 

				}else{
					
					for (i = 0; i < $scope.actualcustomlist.length; i++) {
						
						if(JSON.parse($scope.actualcustomlist[i].templateJson).template.selectedSector == "G" || JSON.parse($scope.actualcustomlist[i].templateJson).template.selectedSector != "M"){
							arraspersector.push($scope.actualcustomlist[i]);
						}
					  } 


				}

				
				$timeout(
					function(){
						$scope.allTemplates.custom = arraspersector;
						$scope.toggleTemplateSelection();
					},100
				)
				

			}

			
		
		
		$scope.selectRecentlyViewedCompany = function (companyObj) {
			$scope.searchCompanies = companyObj.companyName;
			$scope.companyObj = companyObj;
			//$scope.searchCompany();
			
			var arraspersector = [];
			var i = 0;
			
				if(companyObj.fsmFlag == "Manufacturing"){

for (i = 0; i < $scope.actualcustomlist.length; i++) {
						
						if(JSON.parse($scope.actualcustomlist[i].templateJson).template.selectedSector == "G" || JSON.parse($scope.actualcustomlist[i].templateJson).template.selectedSector == "M"){
							arraspersector.push($scope.actualcustomlist[i]);
						}
					  } 

				}else{
					
					for (i = 0; i < $scope.actualcustomlist.length; i++) {
						
						if(JSON.parse($scope.actualcustomlist[i].templateJson).template.selectedSector == "G" || JSON.parse($scope.actualcustomlist[i].templateJson).template.selectedSector == "F"){
							arraspersector.push($scope.actualcustomlist[i]);
						}
					  } 


				}

				console.log(arraspersector);
				$timeout(
					function(){
						$scope.allTemplates.custom = arraspersector;
						$scope.toggleTemplateSelection();
					},100
				)
				

			
		}

		$scope.downloadReport = function() {
			$rootScope.disableGenerationButton = true;
			var reportype = JSON.parse($scope.selectedType);
			var company = {
				"companyCode" : $scope.companyObj.companyCode,
				"companyName": $scope.companyObj.companyName,
				"reportType": reportype.id,
				"reportFormat": reportype.id == 7 ? '1' : '2'
			}
			var url = 'api/companyProfile/generatereportforaxisamcexternal';
			$window.scroll(0,0);
			$http({
					url : url,
					method : 'POST',
					data: company,
					responseType : 'arraybuffer'
				})
				.success(
					function (response, status, headers, config) {
						$scope.getCompanyDownloads();
						if (headers('content-disposition').indexOf(
							'emptydoc') > -1) {
							$scope.contenterror = true;
							$rootScope.disableGenerationButton = false;
							$scope.errorMessage = "No data available for the current selection";
							$scope.message ={
								state: 'fail',
								title: 'Report generation failed',
								message: 'Company Report for - ' + $scope.companyObj.companyName + ' is not available for download.'
							};
							$uibModal.open({
								templateUrl: 'app/companyReport/confirmationModals/confirmationmodal.html',
								size: 'sm',
								scope: $scope,
								controller: 'CustomFilterController'
							})
							$timeout(function () {
								$scope.contenterror = false;
								$scope.errorMessage = [];
							}, 10000);
							return false;
						} else if (reportype.id == 7) {
							var isIE = false || !!document.documentMode;
							$scope.response = response;
							var templateName = 'Company_Report_for_' + $scope.companyObj.companyName + '.xlsx'
							var blob = new Blob(
								[response],
								{
									type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
								});
							if (isIE) {
								window.navigator
									.msSaveOrOpenBlob(
										blob,
										templateName);
							} else {
								var anchor = angular
									.element('<a/>');
								var blob = new Blob(
									[response],
									{
										type: 'application/vnd.ms-excel'
									})
								var objectUrl = (window.URL || window.webkitURL)
									.createObjectURL(blob);
								anchor.css({
									display: 'none'
								});
								angular.element(
									document.body)
									.append(anchor);
								anchor
									.attr({
										href: objectUrl,
										target: '_self',

										download: templateName
									})[0].click();

								anchor.remove();
							}
						} else {
							 if (reportype.id == 5 || reportype.id == 6) {
								var isIE = false || !!document.documentMode;

								var blob = new Blob(
									[response], {
									type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

								});

								if (!isIE) {

									var anchor = angular.element('<a/>');
									var objectUrl = (window.URL || window.webkitURL)
										.createObjectURL(blob);
									anchor.css({
										display: 'none'
									});

									angular.element(document.body).append(
										anchor);
									// Attach to document

									anchor
										.attr({
											href: objectUrl,
											target: '_blank',
											download: 'Company_Report_for_' +
												$scope.companyObj.companyName +
												'.doc'
										})[0].click();

									anchor.remove();
								} else {

									window.navigator
										.msSaveOrOpenBlob(
											blob,
											'Company_Report_for_' +
											$scope.companyObj.companyName +
											'.doc');
								}
							} else {
								var isIE = false || !!document.documentMode;
								$scope.response = response;
								var templateName = 'Company_Report_for_' + $scope.companyObj.companyName + '.pdf';
								var blob = new Blob(
									[response],
									{
										type: 'application/pdf'
									});
								if (isIE) {
									window.navigator
										.msSaveOrOpenBlob(
											blob,
											templateName);
								} else {
									var anchor = angular
										.element('<a/>');
									var blob = new Blob(
										[response],
										{
											type: 'application/pdf'
										})
									var objectUrl = (window.URL || window.webkitURL)
										.createObjectURL(blob);
									anchor.css({
										display: 'none'
									});
									angular.element(
										document.body)
										.append(anchor);
									anchor
										.attr({
											href: objectUrl,
											target: '_self',

											download: templateName
										})[0].click();

									anchor.remove();
								}
							}
						}
						$rootScope.disableGenerationButton = false;
					}).error(function (response, status, headers, config) {
							$rootScope.disableGenerationButton = false;
							$scope.error = false;
							$scope.errorMessage = "";
					})
		}
        $scope.searchCompany = function (reportType, templateJson, event,
			companyName) {
				$scope.showCompanyDetails = false;
				
				var promise = CompanyReportService
					.getCompanyDetails($scope.companyObj.companyCode);
				promise
					.then(function (data) {
						// $scope.showCompanyDetails = true;
						var companyDetails = data.data;
						var companyPeers = companyDetails.peersBenchmark == null ? [] : companyDetails.peersBenchmark.split('$');
						var remainigPeers = companyPeers.slice(1);
						var arr = companyDetails.industry != null ? companyDetails.industry.split('$$$$') : [];
						var industryLevel = [];
						arr.forEach(function (e) {
								var temp = e.split('_');
								var obj = {};
								obj.name = temp[0];
								obj.id = temp[1];
								if (temp[1] == 5) {
									companyDetails.fifthlevelind = temp[0];
								} else if (temp[1] == 4) {
									companyDetails.forthlevelind = temp[0];
								}
								industryLevel
									.push(obj);
					});
					var selectedType = {};
					if(templateJson) {
						selectedType = templateJson;
					} else {
						selectedType = $scope.selectedType && $scope.selectedType != "Select Template Type" ? JSON.parse($scope.selectedType) : undefined;
					}
					$scope.companyObj.irsIndustryNames = $scope.irsNameList;
					$scope.customeJson = (selectedType != null && selectedType != undefined)  ? JSON.parse( selectedType.templateJson) : undefined;
					if((selectedType ? selectedType.id == '3' : reportType == '3') || 
							(($scope.customeJson != null && $scope.customeJson != undefined) ?  ($scope.customeJson != null && $scope.customeJson.template.crisilAnalytics ? $scope.customeJson.template.crisilAnalytics.fsm : false) : false)){
					var promise1 = FinancialSensitivityService
					.getSelectedCompanyDetails($scope.companyObj.companyCode, 'FSM_ALL')
					promise1
					.then(function (data1) {
					
		                	$state.go('companyreportdetails', {
								'companyDetails': data.data,
								'companyObj': $scope.companyObj,
								'companyPeers': companyPeers,
								'remainigPeers': remainigPeers,
								'industryLevel': industryLevel,
								'reportType': reportType ? reportType : selectedType.id,
								'templateJson': selectedType ? selectedType.templateJson : undefined,
								'fsmData':data1,
							})
		                       

					},
		                    
		                    function (errordata) {});
					}else{
						$state.go('companyreportdetails', {
							'companyDetails': data.data,
							'companyObj': $scope.companyObj,
							'companyPeers': companyPeers,
							'remainigPeers': remainigPeers,
							'industryLevel': industryLevel,
							'reportType': reportType ? reportType : selectedType.id,
							'templateJson': selectedType ? selectedType.templateJson : undefined,
							'fsmData':null,
						})
					}
						
					
					//})
				}, function (errorData) {
					$scope.showCompanyDetails = false;
				});
		}

		$scope.userGridCompletion = function(event) {
            downloadReportGrid = event.target;
            downloadReportGrid.validateNow();
		}

		$scope.closeAlert = function() {
			$scope.newCompanyRequest = {};
			$scope.responseMessage = '';
		}

		$scope.changeFormat = function(format) {
			$scope.selectedFormat = format;
		}

		$scope.getCompanyDownloads = function() {
			CompanyReportService.getDownloads().then(
				function(successData) {
					$scope.downloadReportGrid = {
                        //dataProvider : $scope.subscriptionsObj.subscriptionLimit ? response.users : [],
                        dataProvider : successData,
                        delegate : $scope
                    };
					//$scope.companyDownloads = successData;
			}, function(errorData) {

			})
		}

		$scope.getRecentViewedCompanies = function() {
			CompanyReportService.getRecentViewedCompanies().then(
				function(successData) {
					$scope.recentViewedCompanies = successData;
			}, function(errorData) {

			})
		}
		var downloadDto = {}
		
		$window.openModal = function(reportName, reportType, companyName, downloadDate) {
			
			downloadDto = {
				companyName: companyName,
				downloadDate: downloadDate,
				fileFormat: reportName,
				newData: "",
				reportType: reportType,
			}
			$scope.message ={
				state: 'download',
				title: 'Report download',
				message: 'Would you like to re-download the report as generated on '+$filter('date')(downloadDto.downloadDate,'dd-MMM-yyyy')
			};
			$uibModal.open({
				templateUrl: 'app/companyReport/confirmationModals/confirmationmodal.html',
				size: 'sm',
				scope: $scope,
				controller: 'CustomFilterController'
			})
		}

		$scope.applyFiltersModal = function() {
			$uibModal.open({
				templateUrl: 'app/companyReport/customFilters/customfilter.html',
				size: 'md',
				scope: $scope,
				controller: 'ConfirmationModalController'
			})
		}

		$scope.applyFilters = function() {
			CompanyReportService.applyFilters($scope.filters).then(function(response) {
                $scope.downloadReportGrid = {
					dataProvider : response,
					delegate : $scope
				};
			}, function(error) {});
		}

		$scope.downloadCompanyReportFromFiler = function() {
			$http({
				url : 'api/companyProfile/downloadcompanyreportfromfiler',
				method : 'POST',
				data: downloadDto,
				responseType : 'arraybuffer'
			})
			.success(
				function (response, status, headers, config) {
				
					if (downloadDto.fileFormat.indexOf('docx') > 0) {
							var isIE = false || !!document.documentMode;

					var blob = new Blob(
						[response], {
							type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

						});

					if (!isIE) {

						var anchor = angular.element('<a/>');
						var objectUrl = (window.URL || window.webkitURL)
							.createObjectURL(blob);
						anchor.css({
							display: 'none'
						});

						angular.element(document.body).append(
							anchor);
						// Attach to document

						anchor
							.attr({
								href: objectUrl,
								target: '_blank',
								download: 'Company_Report_for_' +
								downloadDto.companyName +
									'.doc'
							})[0].click();

						anchor.remove();
					} else {

						window.navigator
							.msSaveOrOpenBlob(
								blob,
								'Company_Report_for_' +
								downloadDto.companyName +
								'.doc');
					}
						} else if (downloadDto.fileFormat.indexOf('pdf') > 0) {
							var isIE = false || !!document.documentMode;
							$scope.response = response;
							var templateName = 'Company_Report_for_' + downloadDto.companyName + '.pdf';
							var blob = new Blob(
								[response],
								{
									type: 'application/pdf'
								});
							if (isIE) {
								window.navigator
									.msSaveOrOpenBlob(
										blob,
										'Company_Report_for_' + downloadDto.companyName + '.pdf');
							} else {
								var anchor = angular
									.element('<a/>');
								var blob = new Blob(
									[response],
									{
										type: 'application/pdf'
									})
								var objectUrl = (window.URL || window.webkitURL)
									.createObjectURL(blob);
								anchor.css({
									display: 'none'
								});
								angular.element(
									document.body)
									.append(anchor);
								anchor
									.attr({
										href: objectUrl,
										target: '_self',

										download: templateName
									})[0].click();

								anchor.remove();
				}
						} else {
							var templateName = 'Company_Report_for_' + downloadDto.companyName + '.xlsx';
							var isIE = false || !!document.documentMode;
							$scope.response = response;
							var blob = new Blob(
								[response],
								{
									type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
								});
							if (isIE) {
								window.navigator
									.msSaveOrOpenBlob(
										blob,
										templateName);
							} else {
								var anchor = angular
									.element('<a/>');
								var blob = new Blob(
									[response],
									{
										type: 'application/vnd.ms-excel'
									})
								var objectUrl = (window.URL || window.webkitURL)
									.createObjectURL(blob);
								anchor.css({
									display: 'none'
								});
								angular.element(
									document.body)
									.append(anchor);
								anchor
									.attr({
										href: objectUrl,
										target: '_self',

										download: templateName
									})[0].click();

								anchor.remove();
							}
						}
					

				}).error(
				function (response, status, headers, config) {
					vm.entityResponse = response;
					var decodedString = String.fromCharCode
						.apply(null, new Uint8Array(
							vm.entityResponse));
					var obj = JSON.parse(decodedString);
					$scope.error = true;
					$scope.errorMessage = " " + obj.message;
					$timeout(function () {
						$scope.error = false;
						$scope.errorMessage = "";

					}, 2000);
				})
		}

		GenericService.getUserModuleAccessData().then(function(result){
			if(!result['COMPANY_INFO_REPORT1'])
				$scope.report1NotSubscribed = true;
			if(!result['COMPANY_INFO_REPORT2'])
				$scope.report2NotSubscribed = true;
			if(!result['COMPANY_INFO_REPORT3'])
				$scope.report3NotSubscribed = true;
			if (result['COMPANY_INFO_REPORT_LITE_PLUS'] || result['COMPANY_INFO_REPORT_ADVANCED_PLUS'] || result['COMPANY_INFO_REPORT_COMPREHENSIVE_PLUS']) {
				$scope.isPlusSubscribed = true;
			}
			if(AuthKeycloak.authz.hasRealmRole('ROLE_COMPANY_REPORT_ADMIN')) {
				$scope.isCompInfoAdmin = true;
			}
			// if (result['COMPANY_INFO_REPORT2'] || result['COMPANY_INFO_REPORT1'] || result['COMPANY_INFO_REPORT3']) {
			// 	return true;
			// } else {
			// 	ErrorHandlerService.forbiddenError('Company Information Report');
			// 	return false;
			// }
		});

		CompanyReportService.getCurrentUserType().then(function(success) {
			if(success.data && success.data != null) {
				if(success.data.userType == 'Client Admin') {
					$scope.showManagedSubscriptionPage = true;
				}
			}
		}, function(error) {
			$scope.showManagedSubscriptionPage = false;
		})


		$scope.getDate = function(rowData, column) {
            return $filter('date')(rowData.downloadDate,'dd-MMM-yyyy');
		}
		
		$scope.getReportType = function(rowData, column) {
			return rowData.reportType+ $scope.getReportFormat(rowData);
		}
		
		$scope.getNewDataLabel = function(rowData, column) {
			return rowData.newData == 'No new data available' ? rowData.newData : rowData.newData + '<span class="load" onClick= "generateReport(this)"><i class="fa fa-download hover upload-fail grid-svg" title="Download New Report" ></i>';
		}

		$window.generateReport = function(item) {
			console.log(item.parentNode.component.data);
			$scope.companyObj = item.parentNode.component.data;
			if(item.parentNode.component.data.reportType.indexOf('Standard') >= 0) {
				var reportId = item.parentNode.component.data.reportType.indexOf('Lite') >= 0 ? '1' : (item.parentNode.component.data.reportType.indexOf('Advanced') >= 0 ? '2' : '3');
				$scope.searchCompany(reportId);
			} else {
				console.log(item.parentNode.component.data.reportType.split('-')[1]);
				var templateJson = _.find($scope.allTemplates.custom, ['templateName', item.parentNode.component.data.reportType.split('-')[1]]);
				$scope.searchCompany(undefined, templateJson);
			}
			
		}

		$scope.getReportFormat = function(rowData) {
			var format = rowData.fileFormat.split(',');
			var returnTypes = '';
			for (var index = 0; index < format.length; index++) {
				const element = format[index];
				if(element.indexOf('.xlsx') >= 0) {
					returnTypes = returnTypes + '<svg onClick="openModal(\''+element+'\', \''+rowData.reportType+'\', \''+rowData.companyName+'\' , \''+rowData.downloadDate+'\')" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="grid-svg" id="Capa_1" style="enable-background:new 0 0 128 128;" version="1.1" viewBox="0 0 128 128" xml:space="preserve"><style type="text/css">.st0{fill:#21A365;} .st1{fill:#107C41;} .st2{fill:#185B37;} .st3{fill:#33C481;} .st4{fill:#17864C;} .st5{fill:#FFFFFF;} .st6{fill:#036C70;} .st7{fill:#1A9BA1;} .st8{fill:#37C6D0;} .st9{fill:#04878B;} .st10{fill:#4F59CA;} .st11{fill:#7B82EA;} .st12{fill:#4C53BB;} .st13{fill:#0F78D5;} .st14{fill:#29A7EB;} .st15{fill:#0358A8;} .st16{fill:#0F79D6;} .st17{fill:#038387;} .st18{fill:#048A8E;} .st19{fill:#C8421D;} .st20{fill:#FF8F6A;} .st21{fill:#ED6B47;} .st22{fill:#891323;} .st23{fill:#AF2131;} .st24{fill:#C94E60;} .st25{fill:#E08195;} .st26{fill:#B42839;} .st27{fill:#0464B8;} .st28{fill:#0377D4;} .st29{fill:#4FD8FF;} .st30{fill:#1681D7;} .st31{fill:#0178D4;} .st32{fill:#042071;} .st33{fill:#168FDE;} .st34{fill:#CA64EA;} .st35{fill:#7E1FAF;} .st36{fill:#AE4BD5;} .st37{fill:#9332BF;} .st38{fill:#7719AA;} .st39{fill:#0078D4;} .st40{fill:#1490DF;} .st41{fill:#0364B8;} .st42{fill:#28A8EA;} .st43{fill:#41A5ED;} .st44{fill:#2C7BD5;} .st45{fill:#195ABE;} .st46{fill:#103E91;} .st47{fill:#2166C3;} .st48{opacity:0.2;}</style><rect class="st0" height="29.8" width="49.3" x="78.7" y="34.2"/><rect class="st1" height="29.8" width="49.3" x="78.7" y="64"/><rect class="st1" height="29.8" width="49.2" x="29.5" y="34.2"/><path class="st2" d="M78.7,93.8V64H29.6v29.8v4.3v19.6c0,3.2,2.6,5.8,5.8,5.8h86.7c3.2,0,5.8-2.6,5.8-5.8V93.8H78.7z"/><path class="st3" d="M122.1,4.5H78.6v29.8h49.4V10.3C127.9,7.1,125.3,4.5,122.1,4.5z"/><path class="st0" d="M78.7,4.5H35.5c-3.2,0-5.8,2.6-5.8,5.8v23.9h49.1V4.5z"/><path class="st4" d="M59.5,96.5h-53c-3.5,0-6.4-2.9-6.4-6.4V37.9c0-3.5,2.9-6.4,6.4-6.4h53c3.5,0,6.4,2.9,6.4,6.4v52.2  C65.9,93.6,63.1,96.5,59.5,96.5z"/><g><path class="st5" d="M40.5,82.4l-3.9-7.1c-1.6-2.8-2.6-4.7-3.7-6.8h-0.1c-0.9,2.1-1.8,4-3.3,6.8L26,82.4h-7.6l10.8-18.1L18.7,46.5   h7.7l3.9,7.4c1.2,2.2,2.1,4,3,6h0.2c1-2.2,1.7-3.8,2.9-6l3.9-7.4h7.6L37.2,64l11.1,18.4H40.5z"/></g><path class="st48" d="M66.7,37.3c0,0.2,0,0.4,0,0.6v52.2c0,3.5-2.9,6.4-6.4,6.4H30.4v5.7h35.2c3.5,0,6.4-2.9,6.4-6.4V43.6  C72.1,40.4,69.7,37.7,66.7,37.3z"/></svg>'
				} else if(element.indexOf('.docx') >= 0) {
					returnTypes = returnTypes + '<svg onClick="openModal(\''+element+'\', \''+rowData.reportType+'\', \''+rowData.companyName+'\', \''+rowData.downloadDate+'\')" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="grid-svg" id="Capa_1" style="enable-background:new 0 0 128 128;" version="1.1" viewBox="0 0 128 128" xml:space="preserve"><style type="text/css">.st0{fill:#21A365;} .st1{fill:#107C41;} .st2{fill:#185B37;} .st3{fill:#33C481;} .st4{fill:#17864C;} .st5{fill:#FFFFFF;} .st6{fill:#036C70;} .st7{fill:#1A9BA1;} .st8{fill:#37C6D0;} .st9{fill:#04878B;} .st10{fill:#4F59CA;} .st11{fill:#7B82EA;} .st12{fill:#4C53BB;} .st13{fill:#0F78D5;} .st14{fill:#29A7EB;} .st15{fill:#0358A8;} .st16{fill:#0F79D6;} .st17{fill:#038387;} .st18{fill:#048A8E;} .st19{fill:#C8421D;} .st20{fill:#FF8F6A;} .st21{fill:#ED6B47;} .st22{fill:#891323;} .st23{fill:#AF2131;} .st24{fill:#C94E60;} .st25{fill:#E08195;} .st26{fill:#B42839;} .st27{fill:#0464B8;} .st28{fill:#0377D4;} .st29{fill:#4FD8FF;} .st30{fill:#1681D7;} .st31{fill:#0178D4;} .st32{fill:#042071;} .st33{fill:#168FDE;} .st34{fill:#CA64EA;} .st35{fill:#7E1FAF;} .st36{fill:#AE4BD5;} .st37{fill:#9332BF;} .st38{fill:#7719AA;} .st39{fill:#0078D4;} .st40{fill:#1490DF;} .st41{fill:#0364B8;} .st42{fill:#28A8EA;} .st43{fill:#41A5ED;} .st44{fill:#2C7BD5;} .st45{fill:#195ABE;} .st46{fill:#103E91;} .st47{fill:#2166C3;} .st48{opacity:0.2;}</style><path class="st43" d="M128,34.2H29.6V10.3c0-3.2,2.6-5.8,5.8-5.8h86.7c3.2,0,5.8,2.6,5.8,5.8V34.2z"/><rect class="st44" height="29.8" width="98.4" x="29.6" y="34.2"/><rect class="st45" height="29.8" width="98.4" x="29.6" y="64"/><path class="st46" d="M122.2,123.5H35.5c-3.2,0-5.8-2.6-5.8-5.8V93.8H128v23.9C128,120.9,125.4,123.5,122.2,123.5z"/><path class="st47" d="M59.5,96.5h-53c-3.5,0-6.4-2.9-6.4-6.4V37.9c0-3.5,2.9-6.4,6.4-6.4h53c3.5,0,6.4,2.9,6.4,6.4v52.2  C65.9,93.6,63.1,96.5,59.5,96.5z"/><g><path class="st5" d="M19.3,82.4l-8.9-35.9h7.1l3.5,16.3c0.9,4.4,1.8,8.9,2.4,12.5h0.1c0.6-3.8,1.6-8,2.6-12.6L30,46.5h7L40.6,63   c0.9,4.3,1.7,8.2,2.2,12.1h0.1c0.6-4,1.5-8,2.5-12.4l3.8-16.2h6.8l-9.8,35.9H39l-3.8-16.9c-0.9-4-1.6-7.4-2.1-11.3h-0.1   c-0.6,3.8-1.3,7.3-2.4,11.4l-4.2,16.9H19.3z"/></g><path class="st48" d="M65.9,37.3c0,0.2,0,0.4,0,0.6v52.2c0,3.5-2.9,6.4-6.4,6.4H29.7v5.7h35.2c3.5,0,6.4-2.9,6.4-6.4V43.6  C71.3,40.4,69,37.7,65.9,37.3z"/></svg>'
				} else {
					returnTypes = returnTypes + '<i onClick="openModal(\''+element+'\', \''+rowData.reportType+'\', \''+rowData.companyName+'\', \''+rowData.downloadDate+'\')" class="fa fa-file-pdf-o pdf-icon grid-svg" aria-hidden="true"/>'
				}
			}
			return returnTypes;
		}

		$scope.downloadSampleReport =function(sample) {
			 var fd = new FormData();
			 fd.append('reportId', sample.id);
			 $scope.sampleReportName = sample.name;
			jQuery('#SFdocumentPopUp').show();
				jQuery('#SFdocumentPopUpForm').show();
			    jQuery('#SFdocumentHTMLPath').hide()
			    jQuery('#fileNameHiddenRRCrrSf').val(sample.id);
				jQuery('#SFdocumentPopUpForm').submit();
			    jQuery('#SFdocumentPopUp').modal({
			        show: 'false'
			    });
			
		}

		$scope.closePreview = function() {
			jQuery('#SFdocumentPopUp').hide();
		}

		$scope.getCompaniesForAlert = function() {
            CompanyReportService.getCompaniesForAlert().then(function(response) {
                $scope.filtercompanies = response;
			}, function(error) {});
        }
        $scope.filters = {
            selectedCompanies: [],
            fromDate: '',
			toDate: '',
			noChange: false
		};
		$scope.fromDate = new Date();
		$scope.toDate = new Date();
		$scope.usageTrackerGrid = '';
		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy',
				'shortDate', 'dd-MMM-yyyy' ];

		$scope.format = $scope.formats[0];
        $scope.requiredFormat = $scope.formats[4];
		
		$scope.resetFilters = function() {
			$scope.restFilter();
			$scope.getCompanyDownloads(); 
		}

		$scope.getCompanyReportTemplates = function() {
			var subscription = [];
			GenericService.getUserModuleAccessData().then(function (result) {
                if (result['COMPANY_INFO_REPORT1'])
                    subscription.push('S1');
                if (result['COMPANY_INFO_REPORT2'])
                    subscription.push('S2');
                if (result['COMPANY_INFO_REPORT3']) {
					subscription.push('S3');
				}
				if (result['COMPANY REPORT AXIS AMC'] || result['ROLE_COMPANY_REPORT_ADMIN']) {
					subscription.push('AMC');
				}
				CompanyReportService.getCompanyReportTemplates(subscription).then(
						function(successData) {
							$scope.allTemplates = successData;
							$scope.actualcustomlist = $scope.allTemplates.custom;
							if($scope.allTemplates.custom.length > 0 && $scope.allTemplates.standard.length == 0) {
								$scope.isStandard = false;
								
							}
							$scope.rmeMail = successData.rmeMail;
							for(var i = 0; i < successData.standard.length;i++){
								if(successData.standard[i].templateName == "Lite"){
									successData.standard[i].templateJsonString = "Company snapshot covering basic financial and non-financial parameters";
		
								}
								if(successData.standard[i].templateName == "Advanced"){
									successData.standard[i].templateJsonString = "Advanced report covering alternate data indicators in addition to basic parameters";
								}
								if(successData.standard[i].templateName == "Comprehensive"){
									successData.standard[i].templateJsonString = "A comprehensive report including CRISIL IP models and outlook in addition to advance report parameters";
								}
								
							}
							if($scope.isStandard) {
								$scope.sampleReports = $scope.allTemplates.standard;
							} else {
								$scope.sampleReports = $scope.allTemplates.custom;
							}
					}, function(errorData) { })
			});
		}

        $scope.restFilter = function() {
			var d = new Date(); 
			d.setMonth(d.getMonth() - 6);
			$scope.filters.fromDate = d;
			$scope.filters.toDate = new Date();
			$scope.fromDate = d;
			$scope.toDate = new Date();
			$scope.filters.selectedCompanies = [];
			$scope.filters.noChange = false;
		}
		$scope.restFilter();
		
		$scope.hoverIn = function(temp){
			console.log(temp);
			console.log("showing this on hover");
		}

        // $scope.$watch('filters.fromDate', function() {
		// 	if (!$scope.fromDate) {
		// 		return;
		// 	}
		// 	if (!$scope.startMaxDate || $scope.startMaxDate > $scope.fromDate) {
		// 		$scope.endMaxDate = new Date();
		// 	} else {
		// 		$scope.startMaxDate = $scope.fromDate;
		// 	}
		// 	$scope.fromDate = $scope.fromDate;

		// });

		// $scope.$watch('filters.toDate', function() {
		// 	if (!$scope.toDate) {
		// 		return;
		// 	}
		// 	if (!$scope.endMaxDate || ($scope.endMaxDate > $scope.fromDate)) {
		// 		// $scope.endMaxDate = $scope.misReport.toDate;
		// 	} else {
		// 		$scope.startMaxDate = $scope.toDate;
		// 	}
		// 	$scope.toDate = $scope.toDate;
        // });
        
        // $scope.checkErrForSme = function(fromDate, toDate) {
		// 	$scope.errMessage = '';
		// 	$scope.fromDateTrue = false;
		// 	$scope.toDateTrue = false;

		// 	var curDate = new Date();

		// 	if (fromDate != '' && toDate != '') {
		// 		if (new Date(fromDate) > new Date(toDate)) {
		// 			$scope.toDateTrue = false;
		// 			alert("todate should be greater than fromDate.");
		// 			return false;
		// 		} else {
		// 			$scope.toDateTrue = true;
		// 		}
		// 		if (new Date(fromDate) < curDate) {
		// 			$scope.fromDateTrue = true;
		// 		} else {
		// 			$scope.fromDateTrue = false;
		// 			$scope.errMessage = 'fromDate should not be before today.';
		// 			alert("fromDate should not be before today.");
		// 			return false;
		// 		}
		// 	} else {
		// 		$scope.fromDateTrue = true;
		// 		$scope.toDateTrue = true;
		// 	}
		// };

		$scope.popup3 = {
			opened : false
		};
		$scope.popup4 = {
			opened : false
		};
		$scope.open3 = function($event) {
			$scope.popup3.opened = true;
		};
		$scope.open4 = function($event) {
			$scope.popup4.opened = true;
		};

		$scope.createNewTemplate = function() {
			$state.go('createnewtemplate');
			// $state.go('companyreportdetails', {
			// 	'companyDetails': data.data,
			// 	'companyObj': $scope.companyObj,
			// 	'companyPeers': companyPeers,
			// 	'remainigPeers': remainigPeers,
			// 	'industryLevel': industryLevel,
			// 	'reportType': reportType ? reportType : $scope.selectedType
			// })
		}

		
       $scope.getIrsIndustryData = function(){
			
			var promise = GenericService.getLatestIrsIndustryName();
			 promise.then(function (data) {
			 	$scope.irsNameList = data;
//			 	 angular.forEach($scope.irsNameList, function(val, key) {
//              	   
//              	   if($scope.companyDetails.irsCode.indexOf(val.id) > 0){
//              		   
//              		 $scope.filters.selectedirsCompanies.push({"id":val.id,"name":val.name,"labelName":val.labelName,checked:true});
//              		   
//              		   
//              	   }
//						});
			 }, function (response, status, headers, config) {
			 	ErrorHandlerService.handleError(response, status, headers, config);
			 });
			
	
	   }

	   $scope.getRMHref = function() {
			return $scope.rmeMail ? 'mailto:' + $scope.rmeMail : '';
	   }

       $scope.getCompanyReportTemplates();
		 $scope.getIrsIndustryData();
		$window.scroll(0,0);
    }
})();